<template>
  <!--
    给评论人发私信（App 端评论菜单里的「私信」）。
    App 端是直接跳进聊天页；网页端的私信入口一律是这个弹窗（个人主页、粉丝列表同款），
    发完留在当前帖子里，不打断看评论。
    append-to-body：评论区可能在详情弹窗、视频播放器里，不挂 body 会被困在它们的层叠上下文里。
  -->
  <el-dialog
    title="发私信"
    :visible.sync="dialogVisible"
    width="500px"
    append-to-body
    :close-on-click-modal="false"
    :lock-scroll="false"
    @closed="content = ''"
  >
    <div class="comment-dm">
      <div class="comment-dm__to">
        <span>发给：</span>
        <span class="comment-dm__name">{{ (user && user.nickname) || '用户' }}</span>
      </div>
      <el-input
        v-model="content"
        type="textarea"
        :rows="6"
        placeholder="请输入私信内容..."
        maxlength="500"
        show-word-limit
      ></el-input>
    </div>
    <span slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" :loading="sending" @click="send">发送</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { messageFetch } from '@/api'

export default {
  name: 'CommentDmDialog',
  props: {
    visible: { type: Boolean, default: false },
    // { userId, nickname }
    user: { type: Object, default: null }
  },
  data () {
    return {
      content: '',
      sending: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible },
      set (val) { this.$emit('update:visible', val) }
    }
  },
  methods: {
    async send () {
      const text = this.content.trim()
      if (!text) {
        this.$toast.warning('请输入私信内容')
        return
      }
      if (!this.user || !this.user.userId) {
        this.$toast.error('用户信息缺失，请刷新后重试')
        return
      }
      if (this.sending) return
      this.sending = true
      try {
        await messageFetch.sendChatMessage({
          toUserId: this.user.userId,
          content: text,
          imageUrls: [],
          messageType: 1 // 纯文本
        })
        this.$toast.success('发送成功')
        this.dialogVisible = false
      } catch (e) {
        // 失败提示已由请求拦截器统一给出（被拉黑、对方关闭私信等原因由服务端说明）
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-dm__to {
  margin-bottom: 12px;
  font-size: 14px;
  color: #606266;
}

.comment-dm__name {
  color: #303133;
  font-weight: 500;
}
</style>
